import axios from "axios";

// Empty = same origin (the backend serves this build). Set REACT_APP_BACKEND_URL
// at build time only if the API lives on a different host.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mentorai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
